export default "__VITE_ASSET__dddbc842__"